import {GenericContent} from "./GenericContent";
import {Tag} from "../components/generic/BCTag";

export class Challenge extends GenericContent {

    challengeItems: ChallengeItem[]

    constructor(
        navUrl: string,
        name: string,
        description: string,
        thumbnail: string,
        trackingId: string,
        isPremium: boolean,
        alwaysInRoadmap: boolean,
        challengeItems: ChallengeItem[]
    ) {
        super(name, description, thumbnail, navUrl, trackingId, isPremium, alwaysInRoadmap);
        this.challengeItems = challengeItems;
    }
}

export enum AnswerType {
    NUMBER = 'number',
    STRING = 'string'
}

export class ChallengeItem {
    id: string;
    title: string;
    description: string;
    previewDescription: string;
    problem: string;
    tags?: Tag[];
    exampleInput?: string;
    exampleOutput?: string;
    exampleExplanation?: string;
    hints?: string[];
    solution?: string;
    answerType: AnswerType;
    isCompleted?: boolean;

    // Legacy field for backward compatibility
    problemStatement?: string;

    constructor(
        id: string,
        title: string, 
        description: string, 
        previewDescription: string,
        problem: string,
        tags?: Tag[],
        exampleInput?: string,
        exampleOutput?: string,
        hints?: string[],
        solution?: string,
        answerType: AnswerType = AnswerType.NUMBER,
        exampleExplanation?: string,
        problemStatement?: string // Legacy parameter for backward compatibility
    ) {
        this.id = id;
        this.title = title;
        this.description = description;
        this.previewDescription = previewDescription;
        this.problem = problem;
        this.tags = tags;
        this.exampleInput = exampleInput;
        this.exampleOutput = exampleOutput;
        this.exampleExplanation = exampleExplanation;
        this.hints = hints;
        this.solution = solution;
        this.answerType = answerType;
        this.isCompleted = false;
        this.problemStatement = problemStatement; // Keep for backward compatibility
    }
} 